import React from "react";
import formImage from "../../assets/images/png/formImage.png";

const CMYuvaFormPart4 = ({ register, errors }) => {
  return (
    <div className="row g-0 h-100">
      <div className="col-12 col-lg-7 p-4 p-md-5 d-flex flex-column justify-content-center">
        <div className="mb-4">
          <h3 className="fw-bold mb-1">Banking Details</h3>
          <p className="text-gray-300 small">Final step! Enter your preferred bank details for the application.</p>
        </div>

        {/* 8. Bank Name */}
        <div className="mb-3">
          <label className="form-label small fw-bold text-gray-300 text-uppercase">8. Name of Bank</label>
          <input
            type="text"
            className={`form-control form-control-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.bankName ? "is-invalid" : ""}`}
            placeholder="e.g. State Bank of India"
            onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
            {...register("bankName", { 
              required: "Bank name is required", 
              minLength: { value: 3, message: "Bank name is too short" } 
            })}
          />
          {errors.bankName && <div className="invalid-feedback">{errors.bankName.message}</div>}
        </div>

        {/* 9. Branch Name & IFSC (Two Columns) */}
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <label className="form-label small fw-bold text-gray-300 text-uppercase">9. Branch Name</label>
            <input
              type="text"
              className={`form-control form-control-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.branchName ? "is-invalid" : ""}`}
              placeholder="e.g. Civil Lines"
              {...register("branchName", { required: "Branch Name is required" })}
            />
            {errors.branchName && <div className="invalid-feedback">{errors.branchName.message}</div>}
          </div>
          
          <div className="col-md-6">
            <label className="form-label small fw-bold text-gray-300 text-uppercase">IFSC Code</label>
            <input
              type="text"
              className={`form-control form-control-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.ifscCode ? "is-invalid" : ""}`}
              placeholder="SBIN0001234"
              maxLength="11"
              onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
              {...register("ifscCode", { 
                required: "IFSC Code is required",
                // Optional: You can uncomment the regex pattern if you want strict validation
                // pattern: { value: /^[A-Z]{4}0[A-Z0-9]{6}$/, message: "Invalid IFSC Code" }
              })}
            />
            {errors.ifscCode && <div className="invalid-feedback">{errors.ifscCode.message}</div>}
          </div>
        </div>

        {/* 10. Distance */}
        <div className="mb-3">
          <label className="form-label small fw-bold text-gray-300 text-uppercase">10. Branch Distance (km)</label>
          <input
            type="number"
            className={`form-control form-control-lg backdrop-blur-md bg-white/[0.03] border border-white/10 ${errors.branchDistance ? "is-invalid" : ""}`}
            placeholder="e.g. 5"
            {...register("branchDistance", { 
              required: "Distance is required", 
              min: { value: 1, message: "Distance must be at least 1km" },
              valueAsNumber: true 
            })}
          />
          {errors.branchDistance && <div className="invalid-feedback">{errors.branchDistance.message}</div>}
        </div>
      </div>

      {/* Image Side */}
      <div className="col-lg-5 d-none d-lg-block bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a]">
        <img src={formImage} alt="Illustration" className="w-100 h-100 object-fit-cover" />
      </div>
    </div>
  );
};

export default CMYuvaFormPart4;
